(() => {
  // Prevent double-loading
  if (window.__WIB_START_BOX_INIT__) return;
  window.__WIB_START_BOX_INIT__ = true;

  /* ================================================================
     CONFIG
     ================================================================ */
  const ACTION_NAME = "start_box";
  const PARAM_ACTION = "wib_action";
  const PARAM_PRESET = "wib_bb_preset";
  const PARAM_REPLACE = "replace_cart";
  const PARAM_REDIRECT = "redirect_to";

  const LOADER_MESSAGE = "Please wait while we build your bundle and apply your savings…";

  // For subscription bundles, Appstle needs a cart page load (with its
  // own JS running) before it applies the build-a-box discount. We land
  // on /cart with this param, wait for the discount, then reload to /checkout.
  const CART_REFRESH_PARAM = "wib_bb_refresh";
  const CART_REFRESH_MAX_WAIT_MS = 5000;

  // Defaults (URL params can override)
  const DEFAULT_REPLACE_CART = true;
  const DEFAULT_REDIRECT_TO = "/checkout";

  /* ================================================================
     PRESETS
     ================================================================ */
  const BUNDLES = {
    /* =========================
       SUBSCRIPTION (Build-a-Box)
       ========================= */

    essentials_routine: {
      items: [
        {"id":44939471290613,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"CryC-50","__appstle-bb-variants":"44939471290613:1","__appstle-bb-name":"Subscribe and Save"}},
        {"id":40550597918869,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"DBT-50","__appstle-bb-variants":"40550597918869:1","__appstle-bb-name":"Subscribe and Save"}},
        {"id":40550752551061,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"BM-50","__appstle-bb-variants":"40550752551061:1","__appstle-bb-name":"Subscribe and Save"}},
        {"id":44329496641781,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"GG-08","__appstle-bb-variants":"44329496641781:1","__appstle-bb-name":"Subscribe and Save"}}
      ],
      note: ""
    },

    essentials_routine_lp: {
      items: [
        {"id":44939471290613,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"CryC-50","__appstle-bb-variants":"44939471290613:1","__appstle-bb-name":"Subscribe and Save"}},
        {"id":40550597918869,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"DBT-50","__appstle-bb-variants":"40550597918869:1","__appstle-bb-name":"Subscribe and Save"}},
        {"id":40550752551061,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"BM-50","__appstle-bb-variants":"40550752551061:1","__appstle-bb-name":"Subscribe and Save"}}
      ],
      note: ""
    },

    arctic_expedition: {
      items: [
        {"id":40550597918869,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"DBT-50","__appstle-bb-variants":"40550597918869:1","__appstle-bb-name":"Subscribe and Save"}},
        {"id":2584134385701,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"Rar-08","__appstle-bb-variants":"2584134385701:1","__appstle-bb-name":"Subscribe and Save"}},
        {"id":44047429075189,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"Eye-08","__appstle-bb-variants":"44047429075189:1","__appstle-bb-name":"Subscribe and Save"}},
        {"id":44329485566197,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"CryC-08-2","__appstle-bb-variants":"44329485566197:1","__appstle-bb-name":"Subscribe and Save"}},
        {"id":44329496641781,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"GG-08","__appstle-bb-variants":"44329496641781:1","__appstle-bb-name":"Subscribe and Save"}},
        {"id":44329545236725,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"MFF-08","__appstle-bb-variants":"44329545236725:1","__appstle-bb-name":"Subscribe and Save"}},
        {"id":44329481994485,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"BBB-08","__appstle-bb-variants":"44329481994485:1","__appstle-bb-name":"Subscribe and Save"}},
        {"id":44329479504117,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"BM-08","__appstle-bb-variants":"44329479504117:1","__appstle-bb-name":"Subscribe and Save"}},
        {"id":44329273295093,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"7Win-Ret-08","__appstle-bb-variants":"44329273295093:1","__appstle-bb-name":"Subscribe and Save"}}
      ],
      note: ""
    },

    nightly_naturals: {
      items: [
        {"id":42038751690997,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"Chrys-1","__appstle-bb-variants":"42038751690997:1","__appstle-bb-name":"Subscribe and Save"}},
        {"id":40550597918869,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"DBT-50","__appstle-bb-variants":"40550597918869:1","__appstle-bb-name":"Subscribe and Save"}},
        {"id":40550752551061,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"BM-50","__appstle-bb-variants":"40550752551061:1","__appstle-bb-name":"Subscribe and Save"}},
        {"id":43921086152949,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"7Win-Ret-50","__appstle-bb-variants":"43921086152949:1","__appstle-bb-name":"Subscribe and Save"}},
        {"id":44329496641781,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"GG-08","__appstle-bb-variants":"44329496641781:1","__appstle-bb-name":"Subscribe and Save"}}
      ],
      note: ""
    },

    mountain_spring_body_ritual: {
      items: [
        {"id":42125615628533,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"Wintry-100","__appstle-bb-variants":"42125615628533:1","__appstle-bb-name":"Subscribe and Save"}},
        {"id":37682935988373,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"Laurel-1","__appstle-bb-variants":"37682935988373:1","__appstle-bb-name":"Subscribe and Save"}},
        {"id":40550773358741,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"BBB-50","__appstle-bb-variants":"40550773358741:1","__appstle-bb-name":"Subscribe and Save"}},
        {"id":43921094410485,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"MFF-50","__appstle-bb-variants":"43921094410485:1","__appstle-bb-name":"Subscribe and Save"}},
        // One-time add-on (NOT part of subscription)
        {"id":42061284966645,"quantity":1}
      ],
      note: ""
    },

    glow_duo: {
      items: [
        {"id":44939471290613,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"CryC-50","__appstle-bb-variants":"44939471290613:1","__appstle-bb-name":"Subscribe and Save"}},
        {"id":40550597918869,"quantity":1,"selling_plan":4081516789,"properties":{"_appstle-bb-id":"P0KaVn4D","_appstle-bb-product-sku":"DBT-50","__appstle-bb-variants":"40550597918869:1","__appstle-bb-name":"Subscribe and Save"}}
      ],
      note: ""
    },

    /* =========================
       ONE-TIME PURCHASE PRESETS
       ========================= */

    essentials_routine_onetime: {
      items: [
        {"id":47669901951221,"quantity":1}
      ],
      note: ""
    },

    arctic_expedition_onetime: {
      items: [
        {"id":47811763405045,"quantity":1}
      ],
      note: ""
    },

    nightly_naturals_onetime: {
      items: [
        {"id":42038751690997,"quantity":1},
        {"id":40550597918869,"quantity":1},
        {"id":40550752551061,"quantity":1},
        {"id":43921086152949,"quantity":1},
        {"id":44329496641781,"quantity":1}
      ],
      note: ""
    },

    mountain_spring_body_ritual_onetime: {
      items: [
        {"id":42125615628533,"quantity":1},
        {"id":37682935988373,"quantity":1},
        {"id":40550773358741,"quantity":1},
        {"id":43921094410485,"quantity":1},
        {"id":42061284966645,"quantity":1}
      ],
      note: ""
    },

    glow_duo_onetime: {
      items: [
        {"id":48028608659701,"quantity":1}
      ],
      note: ""
    }
  };

  /* ================================================================
     HELPERS
     ================================================================ */
  const root = (window.Shopify?.routes?.root) ? Shopify.routes.root : "/";

  function getLoaderGifUrl() {
    if (window.WIB_LOADER_GIF_URL) return window.WIB_LOADER_GIF_URL;
    return "";
  }

  async function postJSON(path, data) {
    const res = await fetch(root + path.replace(/^\//, ""), {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error(path + " failed (" + res.status + ")");
    return res.json().catch(() => ({}));
  }

  async function getCart() {
    const res = await fetch(root + "cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("cart.js failed (" + res.status + ")");
    return res.json();
  }

  function hasDiscount(cart) {
    if (!cart) return false;
    if ((cart.total_discount || 0) > 0) return true;

    var items = cart.items || [];
    for (var idx = 0; idx < items.length; idx++) {
      var it = items[idx];
      if ((it.total_discount || 0) > 0) return true;
      if (typeof it.original_line_price === "number" &&
          typeof it.final_line_price === "number" &&
          it.final_line_price < it.original_line_price) {
        return true;
      }
    }
    if (typeof cart.original_total_price === "number" &&
        typeof cart.total_price === "number" &&
        cart.total_price < cart.original_total_price) {
      return true;
    }
    return false;
  }

  function presetHasSellingPlan(payload) {
    return (payload?.items || []).some(function(i) {
      return i && i.selling_plan;
    });
  }

  function presetIsAppstleBB(payload) {
    return (payload?.items || []).some(function(i) {
      return i?.properties?.["_appstle-bb-id"];
    });
  }

  function deriveBbAttributes(payload) {
    var first = (payload.items || []).find(function(i) {
      return i?.properties?.["_appstle-bb-id"];
    });
    if (!first) return null;

    var bbId = first.properties["_appstle-bb-id"];
    var bbName = first.properties["__appstle-bb-name"] || "Subscribe and Save";

    var bbVariants = (payload.items || [])
      .filter(function(i) { return i?.properties?.["__appstle-bb-variants"]; })
      .map(function(i) { return i.properties["__appstle-bb-variants"]; })
      .join(",");

    return {
      "_appstle-bb-id": bbId,
      "__appstle-bb-name": bbName,
      "__appstle-bb-variants": bbVariants
    };
  }

  async function pollForDiscount(maxWaitMs) {
    var start = Date.now();
    while (Date.now() - start < maxWaitMs) {
      try {
        var cart = await getCart();
        if (hasDiscount(cart)) return { ok: true, cart: cart };
      } catch (_) {}
      await new Promise(function(r) { setTimeout(r, 200); });
    }
    try {
      var finalCart = await getCart();
      return { ok: hasDiscount(finalCart), cart: finalCart };
    } catch (_) {
      return { ok: false, cart: null };
    }
  }

  function showWibOverlay(message) {
    var gifUrl = getLoaderGifUrl();

    try {
      var old = document.getElementById("wib-finalizing-overlay");
      if (old) old.remove();
    } catch (_) {}

    var overlay = document.createElement("div");
    overlay.id = "wib-finalizing-overlay";
    overlay.style.position = "fixed";
    overlay.style.left = "0";
    overlay.style.top = "0";
    overlay.style.right = "0";
    overlay.style.bottom = "0";
    overlay.style.zIndex = "2147483647";
    overlay.style.background = "rgba(0,0,0,0.25)";
    overlay.style.backdropFilter = "blur(4px)";
    overlay.style.webkitBackdropFilter = "blur(4px)";
    overlay.style.display = "flex";
    overlay.style.alignItems = "center";
    overlay.style.justifyContent = "center";
    overlay.style.padding = "24px";
    overlay.style.cursor = "wait";
    overlay.style.opacity = "0";
    overlay.style.transition = "opacity 420ms ease";

    var card = document.createElement("div");
    card.style.background = "rgba(255,255,255,0.94)";
    card.style.borderRadius = "18px";
    card.style.padding = "22px 22px";
    card.style.boxShadow = "0 18px 60px rgba(0,0,0,0.18)";
    card.style.display = "flex";
    card.style.flexDirection = "column";
    card.style.alignItems = "center";
    card.style.gap = "14px";
    card.style.maxWidth = "560px";
    card.style.width = "min(560px, 92vw)";
    card.style.textAlign = "center";
    card.style.opacity = "0";
    card.style.transform = "translateY(10px)";
    card.style.transition = "opacity 420ms ease, transform 420ms ease";

    var logoWrap = document.createElement("div");
    logoWrap.style.width = "220px";
    logoWrap.style.height = "220px";
    logoWrap.style.borderRadius = "999px";
    logoWrap.style.overflow = "hidden";
    logoWrap.style.display = "flex";
    logoWrap.style.alignItems = "center";
    logoWrap.style.justifyContent = "center";
    logoWrap.style.background = "transparent";

    if (gifUrl) {
      var img = document.createElement("img");
      img.src = gifUrl;
      img.alt = "Loading";
      img.style.width = "100%";
      img.style.height = "100%";
      img.style.objectFit = "contain";
      img.style.display = "block";
      img.style.opacity = "0";
      img.style.transition = "opacity 420ms ease";
      img.onload = function () { img.style.opacity = "1"; };
      setTimeout(function () { try { img.style.opacity = "1"; } catch (_) {} }, 80);
      logoWrap.appendChild(img);
    }

    var text = document.createElement("div");
    text.textContent = message || LOADER_MESSAGE;
    text.style.fontSize = "18px";
    text.style.fontWeight = "650";
    text.style.lineHeight = "1.25";
    text.style.color = "#111";
    text.style.maxWidth = "520px";

    card.appendChild(logoWrap);
    card.appendChild(text);
    overlay.appendChild(card);
    document.body.appendChild(overlay);

    requestAnimationFrame(function () {
      overlay.style.opacity = "1";
      card.style.opacity = "1";
      card.style.transform = "translateY(0)";
    });

    return function remove() {
      try {
        overlay.style.opacity = "0";
        card.style.opacity = "0";
        card.style.transform = "translateY(10px)";
        setTimeout(function () {
          try { overlay.remove(); } catch (_) {}
        }, 460);
      } catch (_) {}
    };
  }

  /* ================================================================
     CART PAGE: Appstle discount refresh
     ================================================================
     Appstle's build-a-box JS only applies the discount after a cart
     page load (it needs the DOM). On the first load we show the
     overlay, poll cart.js until Appstle has done its work, then
     redirect to /checkout so the customer sees correct prices.
     The customer sees the overlay the whole time -- never stale HTML.
     ================================================================ */
  (function cartRefreshBootstrap() {
    if (location.pathname !== "/cart") return;

    var qs = new URLSearchParams(location.search);
    if (qs.get(CART_REFRESH_PARAM) !== "1") return;

    // Overlay covers stale prices immediately
    showWibOverlay(LOADER_MESSAGE);

    (async function() {
      var started = Date.now();
      while (Date.now() - started < CART_REFRESH_MAX_WAIT_MS) {
        try {
          var cart = await getCart();
          if (hasDiscount(cart)) break;
        } catch (_) {}
        await new Promise(function(r) { setTimeout(r, 250); });
      }

      // Redirect to checkout. Shopify renders with the discount
      // baked in. location.replace keeps this out of back-button history.
      location.replace("/checkout?discount=ChillWithUs15");
    })();
  })();

  /* ================================================================
     TRIGGERS
     ================================================================ */
  function parseTriggerFromHref(href) {
    var u = new URL(href || "", window.location.origin);
    var qs = new URLSearchParams(u.search);
    var hs = new URLSearchParams(u.hash.startsWith("#") ? u.hash.slice(1) : "");
    var get = function(k) { return hs.get(k) ?? qs.get(k); };

    var action = get(PARAM_ACTION);
    var preset = get(PARAM_PRESET);
    if (action !== ACTION_NAME || !preset) return null;

    return {
      key: preset,
      replaceCart: (get(PARAM_REPLACE) ?? String(DEFAULT_REPLACE_CART)) === "true",
      redirectTo: get(PARAM_REDIRECT) || DEFAULT_REDIRECT_TO
    };
  }

  function disableEl(el, text) {
    var originalText = el.textContent;
    el.style.pointerEvents = "none";
    el.style.opacity = "0.75";
    if (text) el.textContent = text;
    return function() {
      el.textContent = originalText;
      el.style.pointerEvents = "";
      el.style.opacity = "";
    };
  }

  /* ================================================================
     MAIN CLICK HANDLER
     ================================================================ */
  document.addEventListener("click", async function(e) {
    var dataEl = e.target.closest("[data-appstle-bundle]");
    var linkEl = e.target.closest("a[href*='" + PARAM_ACTION + "=" + ACTION_NAME + "']");
    if (!dataEl && !linkEl) return;

    var key, replaceCart, redirectTo;

    if (dataEl) {
      key = dataEl.getAttribute("data-appstle-bundle");
      replaceCart = (dataEl.getAttribute("data-replace-cart") ?? String(DEFAULT_REPLACE_CART)) === "true";
      redirectTo = dataEl.getAttribute("data-redirect-to") || DEFAULT_REDIRECT_TO;
    } else {
      var trigger = parseTriggerFromHref(linkEl.getAttribute("href"));
      if (!trigger) return;
      key = trigger.key;
      replaceCart = trigger.replaceCart;
      redirectTo = trigger.redirectTo;
    }

    var payload = BUNDLES[key];
    if (!payload) {
      console.error("[WIB] No bundle preset found for key:", key);
      return;
    }

    e.preventDefault();

    var el = dataEl || linkEl;
    var restore = disableEl(el, "Building your box…");
    var removeOverlay = showWibOverlay(LOADER_MESSAGE);

    try {

      // 1) Clear cart if configured
      if (replaceCart) {
        await fetch(root + "cart/clear.js", { method: "POST", credentials: "same-origin" });
      }

      // Purge ALL stale Appstle state so discounts calculate fresh
      try {
        document.cookie = "discount_code=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
        document.cookie = "cart=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";

        Object.keys(sessionStorage).forEach(function(k) {
          if (k.toLowerCase().includes('appstle') || k.toLowerCase().includes('appstle-bb')) {
            sessionStorage.removeItem(k);
          }
        });

        Object.keys(localStorage).forEach(function(k) {
          if (k.toLowerCase().includes('appstle') || k.toLowerCase().includes('appstle-bb')) {
            localStorage.removeItem(k);
          }
        });
      } catch(_) {}

      // Clear any lingering cart attributes from previous bundles
      try {
        await postJSON("/cart/update.js", {
          attributes: {
            "_appstle-bb-id": "",
            "__appstle-bb-name": "",
            "__appstle-bb-variants": ""
          }
        });
      } catch(_) {}

      // 3) Add all items
      await postJSON("/cart/add.js", payload);

      // 4) Set cart attributes (helps Appstle recognize the build-a-box bundle)
      var isBB = presetIsAppstleBB(payload);
      var attrs = isBB ? deriveBbAttributes(payload) : null;

      await postJSON("/cart/update.js", {
        attributes: Object.assign({}, attrs || {}, { wib_touch: String(Date.now()) })
      });

      // 5) Navigate.
      //    For subscription build-a-box bundles, Appstle needs a cart
      //    page load to apply the discount, so we route through /cart.
      //    The cartRefreshBootstrap handles the overlay + redirect to /checkout.
      //    For one-time purchases, go straight to /checkout.
      var isSub = presetHasSellingPlan(payload);
      var needsRefresh = isSub && isBB;

      if (needsRefresh) {
        location.href = "/cart?" + CART_REFRESH_PARAM + "=1";
      } else {
        location.href = "/checkout?discount=ChillWithUs15";
      }

    } catch (err) {
      console.error("[WIB] Error building box:", err);
      try { removeOverlay(); } catch (_) {}
      restore();
    }
  });
})();

/* WI PRESEED 2026-07-13
   ================================================================
   ADDITIVE, self-contained block. Nothing above this comment is
   touched. On the Appstle build-a-box proxy page (path contains
   /apps/subscriptions/bb/), if the URL carries ?wi_preselect=<product-handle>,
   wait for Appstle to hydrate its product grid, then click that
   product's "Add to box" control exactly once and verify the box
   changed. Every step is wrapped so any failure is a silent no-op;
   the block never throws. Production emits no console output. Add
   ?wi_debug=1 to the URL to enable a single channel of console.debug
   tracing.
   ================================================================ */
(function () {
  "use strict";

  // ---- one-time guard -------------------------------------------------
  try {
    if (window.__WI_PRESEED_INIT__) return;
    window.__WI_PRESEED_INIT__ = true;
  } catch (_) { return; }

  // ---- read intent from the URL --------------------------------------
  var DEBUG = false;
  var HANDLE = "";
  try {
    var params = new URLSearchParams(window.location.search || "");
    var d = params.get("wi_debug");
    DEBUG = params.has("wi_debug") && d !== "0" && d !== "false";
    HANDLE = (params.get("wi_preselect") || "").trim().toLowerCase();
  } catch (_) {}

  function dbg() {
    if (!DEBUG) return;
    try { console.debug.apply(console, ["[wi-preseed]"].concat([].slice.call(arguments))); } catch (_) {}
  }

  // ---- gate: only the build-a-box proxy path, only with a handle ------
  try {
    if ((window.location.pathname || "").indexOf("/apps/subscriptions/bb") === -1) return;
    if (!HANDLE) { dbg("no wi_preselect handle; nothing to do"); return; }
  } catch (_) { return; }

  dbg("armed for handle:", HANDLE);

  var MAX_WAIT_MS = 10000;   // hydration budget
  var VERIFY_WAIT_MS = 2500; // post-click verification budget
  var done = false;
  var observer = null;
  var pollTimer = null;
  var deadlineTimer = null;

  // ---- helpers --------------------------------------------------------
  function normalize(s) {
    try {
      return String(s == null ? "" : s)
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    } catch (_) { return ""; }
  }
  function escapeRe(s) {
    try { return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); } catch (_) { return ""; }
  }
  // handle "cryo-c-facial-glow-serum" -> words "cryo c facial glow serum"
  var HANDLE_WORDS = normalize(HANDLE.replace(/-/g, " "));

  // Resolve the handle to its numeric product id + exact title via Shopify's public
  // /products/<handle>.js endpoint. Appstle stamps each box card with a
  // "product-id-<id>" class (verified on the live builder 2026-07-13), which makes the
  // id the strongest possible selector. Resolution is async; the poll/observer loop
  // keeps calling findTarget() and simply gains the primary strategy once these fill.
  var PRODUCT_ID = "";
  var PRODUCT_TITLE_NORM = "";
  try {
    fetch("/products/" + encodeURIComponent(HANDLE) + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (p && p.id) { PRODUCT_ID = String(p.id); dbg("resolved product id", PRODUCT_ID); }
        if (p && p.title) { PRODUCT_TITLE_NORM = normalize(p.title); }
      })
      .catch(function () {});
  } catch (_) {}

  function isButtonish(el) {
    try {
      if (!el) return false;
      var tag = (el.tagName || "").toLowerCase();
      return tag === "button" || tag === "a" || el.getAttribute("role") === "button";
    } catch (_) { return false; }
  }
  function controlText(el) {
    try {
      return normalize(
        (el.textContent || "") + " " +
        (el.getAttribute("aria-label") || "") + " " +
        (el.getAttribute("title") || "") + " " +
        (el.className || "") + " " +
        (el.getAttribute("data-appstle-action") || "")
      );
    } catch (_) { return ""; }
  }
  function isAddControl(el) {
    if (!isButtonish(el)) return false;
    var hay = controlText(el);
    if (!hay) return false;
    if (/\bremove\b|\bdelete\b/.test(hay)) return false; // never a remove
    return /\badd\b/.test(hay);
  }
  function isRemoveControl(el) {
    if (!isButtonish(el)) return false;
    var hay = controlText(el);
    if (!hay) return false;
    return /\bremove\b|\bdelete\b/.test(hay);
  }
  function findAddWithin(root) {
    try {
      var els = root.querySelectorAll ? root.querySelectorAll('button,a,[role="button"]') : [];
      for (var i = 0; i < els.length; i++) { if (isAddControl(els[i])) return els[i]; }
    } catch (_) {}
    return null;
  }
  function cardHasRemove(card) {
    try {
      var els = card.querySelectorAll ? card.querySelectorAll('button,a,[role="button"]') : [];
      for (var i = 0; i < els.length; i++) { if (isRemoveControl(els[i])) return true; }
    } catch (_) {}
    return false;
  }
  function countRemoveControls() {
    var n = 0;
    try {
      var els = document.querySelectorAll('button,a,[role="button"]');
      for (var i = 0; i < els.length; i++) { if (isRemoveControl(els[i])) n++; }
    } catch (_) {}
    return n;
  }
  // small signature of a card's "selected" state for verification
  function cardSig(card, addBtn) {
    try {
      var removeCount = 0;
      var els = card.querySelectorAll ? card.querySelectorAll('button,a,[role="button"]') : [];
      for (var i = 0; i < els.length; i++) { if (isRemoveControl(els[i])) removeCount++; }
      var pressed = "";
      var label = "";
      try { pressed = addBtn ? (addBtn.getAttribute("aria-pressed") || "") : ""; } catch (_) {}
      try { label = addBtn ? normalize(addBtn.textContent) : ""; } catch (_) {}
      return normalize(card.className) + "|" + removeCount + "|" + pressed + "|" + label;
    } catch (_) { return ""; }
  }

  // climb up to a small number of ancestors to find the enclosing card
  // that owns an "add" control; returns { card, addBtn } or null.
  function climbToCardWithAdd(el) {
    try {
      var node = el;
      for (var depth = 0; depth < 8 && node; depth++) {
        var add = findAddWithin(node);
        if (add) return { card: node, addBtn: add };
        node = node.parentElement;
      }
    } catch (_) {}
    return null;
  }

  // prefer Appstle's own increment control inside a card, else any add-ish control
  function addControlIn(card) {
    try {
      var inc = card.querySelector('button[data-action="increment"]');
      if (inc) return inc;
    } catch (_) {}
    return findAddWithin(card);
  }

  // locate the target product's add control, strongest strategy first
  function findTarget() {
    // A0) Appstle card class "product-id-<numeric id>" (verified live 2026-07-13)
    try {
      if (PRODUCT_ID) {
        var idCard = document.querySelector(".product-id-" + PRODUCT_ID);
        if (idCard) {
          var idAdd = addControlIn(idCard);
          if (idAdd) return { card: idCard, addBtn: idAdd };
        }
      }
    } catch (_) {}
    // A1) exact-title match on the card heading (title resolved from /products/<handle>.js)
    try {
      if (PRODUCT_TITLE_NORM) {
        var heads = document.querySelectorAll(".as-group h3, .as-group [class*='title']");
        for (var h = 0; h < heads.length; h++) {
          if (normalize(heads[h].textContent) === PRODUCT_TITLE_NORM) {
            var hit0 = climbToCardWithAdd(heads[h]);
            if (hit0) return { card: hit0.card, addBtn: addControlIn(hit0.card) || hit0.addBtn };
          }
        }
      }
    } catch (_) {}
    // A) explicit product link /products/<handle> (segment-exact)
    try {
      var rx = new RegExp("/products/" + escapeRe(HANDLE) + "(?:[/?#]|$)");
      var links = document.querySelectorAll('a[href*="/products/"]');
      for (var i = 0; i < links.length; i++) {
        var href = (links[i].getAttribute("href") || "").toLowerCase();
        if (rx.test(href)) {
          var hit = climbToCardWithAdd(links[i]);
          if (hit) return hit;
        }
      }
    } catch (_) {}
    // B) data-* attribute carrying the handle
    try {
      var dels = document.querySelectorAll(
        "[data-handle],[data-product-handle],[data-appstle-product-handle],[data-appstle-handle]"
      );
      for (var j = 0; j < dels.length; j++) {
        var el = dels[j];
        var v = "";
        try {
          v = (el.getAttribute("data-handle") ||
               el.getAttribute("data-product-handle") ||
               el.getAttribute("data-appstle-product-handle") ||
               el.getAttribute("data-appstle-handle") || "").toLowerCase().trim();
        } catch (_) {}
        if (v && v === HANDLE) {
          var hit2 = climbToCardWithAdd(el);
          if (hit2) return hit2;
        }
      }
    } catch (_) {}
    // C) fallback: normalized product-title text match
    try {
      if (HANDLE_WORDS && HANDLE_WORDS.length > 2) {
        var titles = document.querySelectorAll(
          '.appstle_product_title,[class*="product-title"],[class*="product_title"],[class*="title"]'
        );
        for (var k = 0; k < titles.length; k++) {
          var tt = normalize(titles[k].textContent);
          if (tt && tt.length > 2 &&
              (tt === HANDLE_WORDS || tt.indexOf(HANDLE_WORDS) !== -1 || HANDLE_WORDS.indexOf(tt) !== -1)) {
            var hit3 = climbToCardWithAdd(titles[k]);
            if (hit3) return hit3;
          }
        }
      }
    } catch (_) {}
    return null;
  }

  function stop() {
    try { if (observer) observer.disconnect(); } catch (_) {}
    try { if (pollTimer) clearInterval(pollTimer); } catch (_) {}
    try { if (deadlineTimer) clearTimeout(deadlineTimer); } catch (_) {}
    observer = null; pollTimer = null; deadlineTimer = null;
  }

  // Appstle stamps the card's stepper wrapper with a quantity-<n> class (quantity-0 = not
  // in box); a decrement control also appears once added. Both observed live 2026-07-13.
  function cardQtyState(card) {
    try {
      var q = card.querySelector('[class*="quantity-"]');
      if (q) {
        var m = (q.className || "").toString().match(/quantity-(\d+)/);
        if (m) return m[1];
      }
    } catch (_) {}
    return "";
  }
  function cardHasDecrement(card) {
    try { return !!card.querySelector('button[data-action="decrement"],[data-action="decrement"]'); } catch (_) { return false; }
  }

  /* 7/22 post-publish fix: the one-shot click raced Appstle's hydration — the early add
     registered transiently, then a later hydration pass reset the box (observed live: the
     "verified" mutation was the transient state; the card reverted to "Add to box"). A LATE
     manual click sticks. So: when the target first appears, wait CLICK_SETTLE_MS and re-resolve
     it (re-renders replace nodes), click, then require the in-box state to PERSIST at
     PERSIST_CHECK_MS; if it reverted, retry with fresh nodes, up to MAX_ATTEMPTS. All paths
     stay silent no-ops. */
  var CLICK_SETTLE_MS = 1200;
  var PERSIST_CHECK_MS = 2000;
  var MAX_ATTEMPTS = 4;
  var attemptsUsed = 0;

  function findCard() {
    try {
      if (PRODUCT_ID) {
        var c = document.querySelector(".product-id-" + PRODUCT_ID);
        if (c) return c;
      }
    } catch (_) {}
    try { var t = findTarget(); return t ? t.card : null; } catch (_) { return null; }
  }
  function inBox(card) {
    try {
      var qty = cardQtyState(card);
      return (qty && qty !== "0") || cardHasDecrement(card) || cardHasRemove(card);
    } catch (_) { return false; }
  }

  function tryClick() {
    try {
      var target = findTarget();          // fresh nodes: re-renders replace the originals
      if (!target || !target.addBtn) { dbg("target lost before click; stopping"); return; }
      if (inBox(target.card)) { dbg("target already in box; done"); return; }
      attemptsUsed++;
      target.addBtn.click();
      dbg("clicked add-to-box (attempt " + attemptsUsed + "/" + MAX_ATTEMPTS + ") for", HANDLE);
      setTimeout(checkPersist, PERSIST_CHECK_MS);
    } catch (_) { dbg("add click threw; stopping silently"); }
  }
  function checkPersist() {
    try {
      var card = findCard();
      if (card && inBox(card)) { dbg("preselect verified and PERSISTED for", HANDLE); return; }
      if (attemptsUsed >= MAX_ATTEMPTS) { dbg("selection kept reverting; giving up after " + attemptsUsed + " attempts"); return; }
      dbg("selection reverted (hydration race); retrying");
      tryClick();
    } catch (_) {}
  }

  function attempt() {
    if (done) return;
    try {
      var target = findTarget();
      if (target) {
        done = true;   // hunt is over; timing is ours now
        stop();        // release hydration watchers
        dbg("target found; settling " + CLICK_SETTLE_MS + "ms before click");
        setTimeout(tryClick, CLICK_SETTLE_MS);
      }
    } catch (_) {}
  }

  function arm() {
    if (done) return;
    // immediate try (in case Appstle already hydrated)
    attempt();
    if (done) return;
    // MutationObserver on the tree as items hydrate in
    try {
      observer = new MutationObserver(function () { attempt(); });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    } catch (_) {}
    // polling backstop
    try { pollTimer = setInterval(attempt, 250); } catch (_) {}
    // hard deadline
    try {
      deadlineTimer = setTimeout(function () {
        if (!done) { stop(); dbg("hydration/timeout budget reached; no target found"); }
      }, MAX_WAIT_MS);
    } catch (_) {}
  }

  try {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", arm, { once: true });
    } else {
      arm();
    }
  } catch (_) {
    try { arm(); } catch (__) {}
  }
})();
